import { ActionReducerMapBuilder, createSlice, Draft, PayloadAction } from "@reduxjs/toolkit";
import { getSystemTriggerCatalog, getTriggers, patchTrigger, postSystemTrigger, postTrigger } from "./thunks";
import { ITriggerData, SystemTriggerCatalogItem, TriggerEdit } from "../../entities/trigger";
import { RootState } from "..";
import { ResponseMetaData } from "../../entities/global";

interface TriggerState {
  triggers: ITriggerData[]
  /** Internal events available to subscribe to — loaded lazily by the trigger page. */
  systemCatalog: SystemTriggerCatalogItem[],
  trigger?: TriggerEdit,
  loading: boolean,
  loadingError: boolean,
  saveLoading: boolean,
  meta: ResponseMetaData
}

const initialState: TriggerState = {
  triggers: [],
  systemCatalog: [],
  loading: false,
  saveLoading: false,
  loadingError: false,
  meta: {
    limit: 250,
    page: 1,
    pages: 1,
    total: 0,
  }
}

const saveLoaderTrigger = (
  builder: ActionReducerMapBuilder<TriggerState>,
  action: any
) => {
  builder.addCase(action.pending, (state: TriggerState) => {
    state.saveLoading = true;
  });

  builder.addCase(action.fulfilled, (state: TriggerState) => {
    state.saveLoading = false;
  });
  builder.addCase(action.rejected, (state: TriggerState) => {
    state.saveLoading = false;
  });
};

export const triggerSlice = createSlice({
  name: "tigger",
  initialState,
  reducers: {
    onHandlerTrigger: (state: Draft<TriggerState>, action: PayloadAction<TriggerEdit>) => {
      state.trigger = action.payload;
    },
    onClearState: (state: Draft<TriggerState>) => {
      state.trigger = undefined;
    }
  },
  extraReducers: (builder) => {
    builder.addCase(getTriggers.pending, (state) => {
      state.loading = true;
      state.loadingError = false;
    })
    builder.addCase(getTriggers.fulfilled, (state, action) => {
      const { data, ...meta } = action.payload;
      state.triggers = data;
      state.meta = meta;
      if (action.payload.data.length === 0) {
        state.loadingError = true;
      }
      state.loading = false;
    })
    builder.addCase(getTriggers.rejected, (state) => {
      state.loading = false;
      state.loadingError = true;
    })
    builder.addCase(getSystemTriggerCatalog.fulfilled, (state, action) => {
      state.systemCatalog = action.payload;
    })

    const saveActions = [postTrigger, postSystemTrigger, patchTrigger];

    saveActions.forEach((action) => { saveLoaderTrigger(builder, action) })
  },
});

export const { onHandlerTrigger, onClearState } = triggerSlice.actions;

export const selectTriggerState = (state: RootState) => state.trigger;

export default triggerSlice.reducer;
